import { ensureError, ensureHelp, ensureLabel, type FieldType } from './base.js';
import { withCustomMessage } from './text.js';
import { t } from '../../i18n/index.js';

/**
 * `<plp-field type="radio" name="X" value="A">` — один radio-вариант.
 * Группируется с другими radio-полями того же `name` внутри `<plp-form>`.
 * Лейбл такого поля = label всего варианта.
 */
export const radioType: FieldType = {
  render(ctx) {
    let wrap = ctx.host.querySelector<HTMLLabelElement>(':scope > label.plp-field-radio');
    if (!wrap) {
      wrap = document.createElement('label');
      wrap.className = 'plp-field-radio';
      const input = document.createElement('input');
      input.type = 'radio';
      input.className = 'plp-field-input';
      const text = document.createElement('span');
      text.className = 'plp-field-label-text';
      wrap.appendChild(input);
      wrap.appendChild(text);
      ctx.host.insertBefore(wrap, ctx.host.querySelector(':scope > .plp-field-error'));
    }
    const input = wrap.querySelector<HTMLInputElement>('input[type="radio"]')!;
    const text = wrap.querySelector<HTMLElement>('.plp-field-label-text')!;
    input.name = ctx.name;
    input.value = ctx.host.getAttribute('value') ?? '';
    text.textContent = ctx.label ?? '';
    // Required отметка не на каждом радио, а на всей группе — её ставит форма.
    ensureError(ctx.host);
    ensureHelp(ctx.host, ctx.help);
    // ensureLabel вызывается чтобы убрать standalone <label>, если был
    ensureLabel(ctx.host, undefined, false);
  },

  getValue(ctx) {
    const input = ctx.host.querySelector<HTMLInputElement>('input[type="radio"]');
    return input?.checked ? input.value : '';
  },

  validate(ctx) {
    if (!ctx.required) return { valid: true };
    // Проверяем по всей группе name внутри ближайшей формы — сабмит-уровень
    const form = ctx.host.closest('plp-form, form');
    const checked = form?.querySelector<HTMLInputElement>(
      `input[type="radio"][name="${CSS.escape(ctx.name)}"]:checked`
    );
    if (!checked) {
      return withCustomMessage({ valid: false, error: t('form.validation.selectOption') }, ctx);
    }
    return { valid: true };
  },

  shouldSubmit(ctx) {
    const input = ctx.host.querySelector<HTMLInputElement>('input[type="radio"]');
    return Boolean(input?.checked);
  },

  setDisabled(ctx, disabled) {
    const input = ctx.host.querySelector<HTMLInputElement>('input[type="radio"]');
    if (input) input.disabled = disabled;
  },
};
